import mapboxgl, { GeoJSONSource } from 'mapbox-gl';
import MapLayer from '../map-layer.enum';

function onIndustryNewsClusterClick(
  map: mapboxgl.Map,
  industryNewsCluster: GeoJSON.Feature<GeoJSON.Point, Record<string, any>>
) {
  const clusterId = industryNewsCluster.properties?.cluster_id;
  (
    map.getSource(MapLayer.INDUSTRY_NEWS) as GeoJSONSource
  ).getClusterExpansionZoom(clusterId, (err, zoom) => {
    if (err) return;

    map.easeTo({
      center: industryNewsCluster.geometry.coordinates as [number, number],
      zoom: zoom + 0.5,
    });
  });
}

export default onIndustryNewsClusterClick;
